// Auto-generated by build-env.js, do not edit manually.
export const BUILD_INFO = {
  "VERSION": "v.2026.0825.18.45",
  "VER_USER": "yuese.sun",
  "VER_COMMIT": "9b43ea7b98422ba0ae0b8f6c547ebc4a0e199d72",
  "BUILD_TIME": "2026-08-25 18:45:42"
};
